export default "__VITE_ASSET__Dh1GOf4k__"